import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';
import { Section, SectionTitle, SectionSubtitle } from '../components/Section';
import { FeatureList } from '../components/FeatureList';
import { CTAButton } from '../components/CTAButton';
import { LanguageModal } from '../components/LanguageModal';
import { PricingSection } from '../components/PricingSection';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { useLanguage } from '../context/LanguageContext';
export function LandingPage() {
  const {
    t,
    language
  } = useLanguage();
  return <main className="bg-matrix-bg min-h-screen overflow-x-hidden relative px-[10px]" data-id="element-240">
      <LanguageModal data-id="element-241" />
      <RecentPurchaseToast data-id="element-242" />
      <Hero data-id="element-243" />

      {/* LA VIDA DOBLE DEL "DESPIERTO A MEDIAS" */}
      <Section className="bg-matrix-bg-light" data-id="element-244">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-245">
          <SectionTitle data-id="element-246">{t.doubleLife.title}</SectionTitle>

          <p className="text-white text-lg mb-6" data-id="element-247">{t.doubleLife.intro}</p>

          <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-248">
            <div className="bg-matrix-bg/50 p-5 rounded-xl border border-matrix-muted/20" data-id="element-249">
              <SectionSubtitle className="text-white" data-id="element-250">
                {t.doubleLife.externalTitle}
              </SectionSubtitle>
              <FeatureList items={t.doubleLife.externalItems} data-id="element-251" />
              <p className="text-white mt-3 italic" data-id="element-252">
                {t.doubleLife.externalNote}
              </p>
            </div>

            <div className="bg-matrix-bg/50 p-5 rounded-xl border border-matrix-accent/20" data-id="element-253">
              <SectionSubtitle className="text-matrix-accent" data-id="element-254">
                {t.doubleLife.internalTitle}
              </SectionSubtitle>
              <FeatureList items={t.doubleLife.internalItems} data-id="element-255" />
            </div>
          </div>

          <div className="text-center space-y-3 text-white text-lg" data-id="element-256">
            <p className="font-semibold" data-id="element-257">{t.doubleLife.however}</p>
            <p data-id="element-258">{t.doubleLife.whenClose}</p>
            <p className="text-matrix-accent font-bold text-xl" data-id="element-259">
              {t.doubleLife.realityStays}
            </p>
            <p data-id="element-260">{t.doubleLife.samePatterns}</p>
            <p className="italic" data-id="element-261">{t.doubleLife.hurts}</p>
          </div>
        </div>
      </Section>

      {/* NO ESTÁS ROTO. ESTÁS PROGRAMADO. */}
      <Section data-id="element-262">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-263">
          <SectionTitle data-id="element-264">{t.programmed.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-265">{t.programmed.intro}</p>

          <div className="bg-matrix-bg-light p-5 rounded-xl mb-6 border-l-4 border-matrix-muted" data-id="element-266">
            <FeatureList variant="default" items={t.programmed.systemSays} className="text-white italic" data-id="element-267" />
          </div>

          <p className="text-white text-lg mb-5" data-id="element-268">{t.programmed.repeated}</p>
          <p className="text-white text-lg mb-6" data-id="element-269">{t.programmed.becameNormal}</p>

          <SectionSubtitle data-id="element-270">{t.programmed.programmedForTitle}</SectionSubtitle>
          <FeatureList items={t.programmed.programmedForItems} className="mb-6" data-id="element-271" />

          <div className="bg-gradient-to-r from-matrix-accent/10 to-matrix-accent-secondary/10 p-6 rounded-xl border border-matrix-accent/30" data-id="element-272">
            <p className="text-white text-lg font-semibold mb-2" data-id="element-273">
              {t.programmed.truthIs}
            </p>
            <p className="text-matrix-accent text-xl md:text-2xl font-bold" data-id="element-274">
              {t.programmed.notBlocked}
            </p>
          </div>
        </div>
      </Section>

      {/* YA NO TE FALTA CONTENIDO. TE FALTA UN MAPA. */}
      <Section className="bg-matrix-bg-light" data-id="element-275">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-276">
          <SectionTitle data-id="element-277">{t.needMap.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-278">{t.needMap.seenEverything}</p>
          <FeatureList items={t.needMap.seenItems} className="mb-6" data-id="element-279" />

          <p className="text-white text-lg font-medium mb-5" data-id="element-280">
            {t.needMap.youKnow}
          </p>
          <p className="text-white text-lg mb-6" data-id="element-281">{t.needMap.butNoOne}</p>

          <div className="space-y-3 mb-6" data-id="element-282">
            {t.needMap.quotes.map((quote, index) => <div key={index} className="bg-matrix-bg p-4 rounded-lg border-l-4 border-matrix-accent" data-id="element-283">
                <p className="text-white italic" data-id="element-284">{quote}</p>
              </div>)}
          </div>

          <p className="text-white text-lg mb-3" data-id="element-285">{t.needMap.marathons}</p>
          <p className="text-matrix-accent text-xl font-bold mb-6" data-id="element-286">
            {t.needMap.knowTooMuch}
          </p>
          <p className="text-white text-lg mb-6" data-id="element-287">{t.needMap.needProtocol}</p>

          <p className="text-white text-lg font-medium mb-4" data-id="element-288">
            {t.needMap.enterHere}
          </p>

          <div className="bg-gradient-to-r from-matrix-accent/10 to-matrix-accent-secondary/10 p-6 rounded-xl border border-matrix-accent/30" data-id="element-289">
            <p className="text-white text-lg font-semibold mb-2" data-id="element-290">
              {t.programmed.truthIs}
            </p>
            <p className="text-matrix-accent text-xl md:text-2xl font-bold" data-id="element-291">
              {t.programmed.notBlocked}
            </p>
          </div>
        </div>
      </Section>

      {/* Target Audience */}
      <Section data-id="element-292">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-293">
          <p className="text-white text-lg mb-5" data-id="element-294">{t.targetAudience.notPdf}</p>
          <p className="text-white text-lg font-medium mb-5" data-id="element-295">
            {t.targetAudience.designedFor}
          </p>
          <FeatureList items={t.targetAudience.items} data-id="element-296" />
        </div>
      </Section>

      {/* EL MECANISMO QUE NADIE TE EXPLICÓ */}
      <Section className="bg-matrix-bg-light" data-id="element-297">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-298">
          <SectionTitle data-id="element-299">{t.mechanism.title}</SectionTitle>

          <p className="text-white text-lg mb-3" data-id="element-300">{t.mechanism.rootProblem}</p>
          <p className="text-matrix-accent text-xl font-bold mb-6" data-id="element-301">
            {t.mechanism.rootIs}
          </p>

          <p className="text-white text-lg mb-3" data-id="element-302">{t.mechanism.osIs}</p>
          <p className="text-white text-xl font-semibold mb-6" data-id="element-303">
            {t.mechanism.formula}
          </p>
          <p className="text-white text-lg mb-6" data-id="element-304">{t.mechanism.ifNotRewrite}</p>

          <p className="text-white text-lg mb-6" data-id="element-305">{t.mechanism.showsHow}</p>

          <div className="grid md:grid-cols-3 gap-5 mb-6" data-id="element-306">
            <motion.div className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/30" whileInView={{
            opacity: 1,
            y: 0
          }} initial={{
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.1
          }} data-id="element-307">
              <div className="text-5xl font-black text-matrix-accent text-glow mb-3" data-id="element-308">
                {t.mechanism.three.number}
              </div>
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-309">
                {t.mechanism.three.title}
              </h4>
              <p className="text-white mb-3" data-id="element-310">{t.mechanism.three.desc}</p>
              <FeatureList items={t.mechanism.three.items} data-id="element-311" />
            </motion.div>

            <motion.div className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/30" whileInView={{
            opacity: 1,
            y: 0
          }} initial={{
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.2
          }} data-id="element-312">
              <div className="text-5xl font-black text-matrix-accent text-glow mb-3" data-id="element-313">
                {t.mechanism.six.number}
              </div>
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-314">
                {t.mechanism.six.title}
              </h4>
              <p className="text-white mb-3" data-id="element-315">{t.mechanism.six.desc}</p>
              <FeatureList items={t.mechanism.six.items} data-id="element-316" />
            </motion.div>

            <motion.div className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/30" whileInView={{
            opacity: 1,
            y: 0
          }} initial={{
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.3
          }} data-id="element-317">
              <div className="text-5xl font-black text-matrix-accent text-glow mb-3" data-id="element-318">
                {t.mechanism.nine.number}
              </div>
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-319">
                {t.mechanism.nine.title}
              </h4>
              <p className="text-white mb-3" data-id="element-320">{t.mechanism.nine.desc}</p>
              <FeatureList items={t.mechanism.nine.items} data-id="element-321" />
            </motion.div>
          </div>

          <p className="text-matrix-accent text-xl font-bold text-center" data-id="element-322">
            {t.mechanism.stopWriting}
          </p>
        </div>
      </Section>

      {/* 3 METÁFORAS */}
      <Section data-id="element-323">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-324">
          <SectionTitle data-id="element-325">{t.metaphors.title}</SectionTitle>

          <div className="space-y-5" data-id="element-326">
            <div className="bg-matrix-bg-light p-5 rounded-xl" data-id="element-327">
              <h4 className="text-xl font-bold text-matrix-accent mb-2" data-id="element-328">
                {t.metaphors.spotify.title}
              </h4>
              <p className="text-white" data-id="element-329">{t.metaphors.spotify.desc}</p>
            </div>

            <div className="bg-matrix-bg-light p-5 rounded-xl" data-id="element-330">
              <h4 className="text-xl font-bold text-matrix-accent mb-2" data-id="element-331">
                {t.metaphors.glitch.title}
              </h4>
              <p className="text-white" data-id="element-332">{t.metaphors.glitch.desc}</p>
            </div>

            <div className="bg-matrix-bg-light p-5 rounded-xl" data-id="element-333">
              <h4 className="text-xl font-bold text-matrix-accent mb-2" data-id="element-334">
                {t.metaphors.player.title}
              </h4>
              <p className="text-white" data-id="element-335">{t.metaphors.player.desc}</p>
            </div>
          </div>
        </div>
      </Section>

      {/* ¿QUÉ HAY DENTRO? */}
      <Section className="bg-matrix-bg-light" data-id="element-336">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-337">
          <SectionTitle data-id="element-338">{t.whatsInside.title}</SectionTitle>

          <div className="space-y-8" data-id="element-339">
            {/* Radiografía */}
            <div data-id="element-340">
              <SectionSubtitle className="text-matrix-accent" data-id="element-341">
                {t.whatsInside.radiography.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-342">
                {t.whatsInside.radiography.intro}
              </p>
              <p className="text-white mb-3" data-id="element-343">
                {t.whatsInside.radiography.desc}
              </p>
              <FeatureList items={t.whatsInside.radiography.items} data-id="element-344" />
              <p className="text-white mt-3 italic" data-id="element-345">
                {t.whatsInside.radiography.note}
              </p>
            </div>

            {/* Desprogramación */}
            <div data-id="element-346">
              <SectionSubtitle className="text-matrix-accent" data-id="element-347">
                {t.whatsInside.deprogramming.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-348">
                {t.whatsInside.deprogramming.desc}
              </p>
              <FeatureList items={t.whatsInside.deprogramming.items} data-id="element-349" />
              <p className="text-matrix-accent mt-3 font-semibold" data-id="element-350">
                {t.whatsInside.deprogramming.note}
              </p>
            </div>

            {/* El código 3-6-9 */}
            <div data-id="element-351">
              <SectionSubtitle className="text-matrix-accent" data-id="element-352">
                {t.whatsInside.code369.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-353">{t.whatsInside.code369.intro}</p>
              <p className="text-white mb-3" data-id="element-354">{t.whatsInside.code369.desc}</p>
              <FeatureList items={t.whatsInside.code369.items} data-id="element-355" />
              <p className="text-matrix-accent mt-3 font-semibold" data-id="element-356">
                {t.whatsInside.code369.note}
              </p>
            </div>

            {/* Tu cápsula */}
            <div data-id="element-357">
              <SectionSubtitle className="text-matrix-accent" data-id="element-358">
                {t.whatsInside.capsule.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-359">{t.whatsInside.capsule.desc}</p>
              <FeatureList items={t.whatsInside.capsule.items} data-id="element-360" />
              <p className="text-white mt-3 italic" data-id="element-361">
                {t.whatsInside.capsule.note}
              </p>
            </div>

            {/* Reto 21 días */}
            <div data-id="element-362">
              <SectionSubtitle className="text-matrix-accent" data-id="element-363">
                {t.whatsInside.challenge.title}
              </SectionSubtitle>
              <p className="text-white text-xl font-bold mb-3" data-id="element-364">
                {t.whatsInside.challenge.gameChanger}
              </p>
              <p className="text-white mb-3" data-id="element-365">{t.whatsInside.challenge.desc}</p>
              <FeatureList items={t.whatsInside.challenge.items} data-id="element-366" />
              <p className="text-white mt-3" data-id="element-367">
                {t.whatsInside.challenge.notImpossible}
              </p>
              <p className="text-white mt-3" data-id="element-368">
                {t.whatsInside.challenge.sameLogic}
              </p>
              <p className="text-matrix-accent text-xl font-bold mt-2" data-id="element-369">
                {t.whatsInside.challenge.formula}
              </p>
              <p className="text-white mt-3" data-id="element-370">
                {t.whatsInside.challenge.inYourFavor}
              </p>
            </div>
          </div>

          {/* Mid-page CTA */}
          <div className="text-center mt-10" data-id="element-371">
            <CTAButton size="large" href="#pricing" data-id="element-372">
              {t.whatsInside.midCta}
            </CTAButton>
          </div>
        </div>
      </Section>

      {/* ¿QUÉ PASA DESPUÉS DE 21 DÍAS? */}
      <Section data-id="element-373">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-374">
          <SectionTitle data-id="element-375">{t.after21.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-376">{t.after21.noPromise}</p>
          <p className="text-white text-lg font-medium mb-6" data-id="element-377">
            {t.after21.promiseReal}
          </p>

          <FeatureList items={t.after21.items} variant="check" className="mb-6" data-id="element-378" />

          <p className="text-matrix-accent text-xl font-bold" data-id="element-379">
            {t.after21.notBecause}
          </p>
        </div>
      </Section>

      {/* ESTE MANUAL ES PARA TI SI… */}
      <Section className="bg-matrix-bg-light" data-id="element-380">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-381">
          <div className="grid md:grid-cols-2 gap-6" data-id="element-382">
            <div data-id="element-383">
              <SectionTitle className="text-matrix-accent-secondary" data-id="element-384">
                {t.forYou.title}
              </SectionTitle>
              <FeatureList variant="check" items={t.forYou.items} data-id="element-385" />
            </div>

            <div data-id="element-386">
              <SectionTitle className="text-matrix-muted" data-id="element-387">
                {t.notForYou.title}
              </SectionTitle>
              <FeatureList items={t.notForYou.items} data-id="element-388" />
            </div>
          </div>
        </div>
      </Section>

      {/* ¿PERO DE VERDAD FUNCIONA? */}
      <Section data-id="element-389">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-390">
          <SectionTitle data-id="element-391">{t.doesItWork.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-392">{t.doesItWork.realQuestion}</p>
          <p className="text-matrix-accent text-xl font-bold mb-6" data-id="element-393">
            {t.doesItWork.areYouWilling}
          </p>

          <p className="text-white text-lg mb-3" data-id="element-394">{t.doesItWork.notMagic}</p>
          <p className="text-white text-xl font-bold mb-6" data-id="element-395">
            {t.doesItWork.worksIf}
          </p>

          <p className="text-white text-lg mb-6" data-id="element-396">{t.doesItWork.ifYou}</p>

          <p className="text-white text-lg font-medium mb-4" data-id="element-397">
            {t.doesItWork.guarantee}
          </p>
          <FeatureList variant="check" items={t.doesItWork.guaranteeItems} data-id="element-398" />
        </div>
      </Section>

      {/* ¿QUÉ RECIBES EXACTAMENTE? */}
      <Section className="bg-matrix-bg-light" data-id="element-399">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-400">
          <SectionTitle data-id="element-401">{t.whatYouReceive.title}</SectionTitle>

          <p className="text-white text-lg mb-6" data-id="element-402">{t.whatYouReceive.when}</p>

          <div className="grid md:grid-cols-2 gap-5 mb-6" data-id="element-403">
            {t.whatYouReceive.items.map((item, index) => <div key={index} className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/20" data-id="element-404">
                <div className="text-3xl mb-2" data-id="element-405">{item.emoji}</div>
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-406">
                  {item.title}
                </h4>
                <p className="text-white" data-id="element-407">{item.desc}</p>
              </div>)}
          </div>

          <p className="text-white text-lg text-center" data-id="element-408">
            {t.whatYouReceive.accessible}
          </p>
        </div>
      </Section>

      {/* IMAGINA TU VIDA 21 DÍAS DESPUÉS… */}
      <Section data-id="element-409">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-410">
          <SectionTitle data-id="element-411">{t.imagine.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-412">{t.imagine.same}</p>
          <p className="text-white text-xl font-bold mb-6" data-id="element-413">
            {t.imagine.butYou}
          </p>

          <FeatureList variant="check" items={t.imagine.items} className="mb-6" data-id="element-414" />

          <p className="text-matrix-accent text-2xl font-bold text-center" data-id="element-415">
            {t.imagine.notMotivation}
          </p>
        </div>
      </Section>

      {/* PRICING SECTION */}
      <Section className="bg-matrix-bg-light" id="pricing" data-id="element-416">
        <PricingSection data-id="element-417" />
      </Section>

      {/* FINAL CTA */}
      <Section className="bg-gradient-to-b from-matrix-bg-light to-matrix-bg" data-id="element-418">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-419">
          <SectionTitle className="text-white" data-id="element-420">{t.finalCta.title}</SectionTitle>

          <p className="text-white text-lg mb-6" data-id="element-421">{t.finalCta.moment}</p>

          <p className="text-white text-lg font-medium mb-5" data-id="element-422">
            {t.finalCta.twoOptions}
          </p>

          <div className="grid md:grid-cols-2 gap-5 mb-8 max-w-3xl mx-auto" data-id="element-423">
            <div className="bg-matrix-bg p-5 rounded-xl border border-matrix-muted/30" data-id="element-424">
              <p className="text-white" data-id="element-425">{t.finalCta.option1}</p>
            </div>

            <div className="bg-gradient-to-r from-matrix-accent/10 to-matrix-accent-secondary/10 p-5 rounded-xl border border-matrix-accent/50" data-id="element-426">
              <p className="text-white font-medium" data-id="element-427">{t.finalCta.option2}</p>
            </div>
          </div>

          <p className="text-white text-lg mb-6" data-id="element-428">{t.finalCta.ifSecond}</p>

          <div className="space-y-3 text-white text-lg mb-8" data-id="element-429">
            {t.finalCta.steps.map((step, index) => <p key={index} className={index === t.finalCta.steps.length - 1 ? 'text-matrix-accent font-semibold' : ''} data-id="element-430">
                {step}
              </p>)}
          </div>

          <p className="text-white text-lg mb-3" data-id="element-431">{t.finalCta.everyPage}</p>
          <p className="text-white text-lg font-medium mb-8" data-id="element-432">
            {t.finalCta.clearMessage}
          </p>

          <motion.p className="text-2xl md:text-3xl font-black text-matrix-accent text-glow mb-8" animate={{
          textShadow: ['0 0 10px rgba(0, 217, 255, 0.5), 0 0 20px rgba(0, 217, 255, 0.3)', '0 0 20px rgba(0, 217, 255, 0.8), 0 0 40px rgba(0, 217, 255, 0.5)', '0 0 10px rgba(0, 217, 255, 0.5), 0 0 20px rgba(0, 217, 255, 0.3)']
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-433">
            {t.finalCta.quote}
          </motion.p>

          <div className="space-y-4 mb-8" data-id="element-434">
            <p className="text-white text-xl font-bold" data-id="element-435">{t.finalCta.notWhat}</p>
            <p className="text-matrix-accent text-2xl font-black" data-id="element-436">
              {t.finalCta.youAre}
            </p>
          </div>

          <CTAButton size="large" className="mb-6" data-id="element-437">
            {t.finalCta.cta}
          </CTAButton>

          <p className="text-white text-sm" data-id="element-438">{t.finalCta.access}</p>
        </div>
      </Section>

      {/* Footer */}
      <footer className="py-6 border-t border-matrix-muted/20" data-id="element-439">
        <div className="container mx-auto px-4 text-center" data-id="element-440">
          <p className="text-sm" style={{
          color: '#00d2f7'
        }} data-id="element-441">
            © {new Date().getFullYear()}{' '}
            {language === 'es' ? 'ROMPE LA MATRIX' : 'BREAK THE MATRIX'} 3-6-9.{' '}
            {t.footer.rights}
          </p>
        </div>
      </footer>
    </main>;
}